export const getSearchResults = (
  debouncedSearchValue: string,
  searchData: any,
  searchResultsSection: string,
  setValue: (val: string) => void,
  setSearchResultsSection: (val: string) => void,
  setKeysToType: (val: any) => void,
  setKeysToNames: (val: any) => void,
  setSearchTabs: (val: any) => void,
  setSearchResultsArr: (val: any) => void,
  setSearchResultsTotal: (val: any) => void,
  cleanKey: (val: string) => string,
  sortByIndex: (arr: any, val: string, type: string) => any,
) => {
  if (debouncedSearchValue === '') {
    const searchResults: { [key: string]: any } = {};
    const keysToNamesIn: { [key: string]: any } = {};
    const keysToTypeIn: { [key: string]: any } = {};

    const setBlockIfNeeded = (category: string, type: string) => {
      if (!searchResults[cleanKey(category)]) {
        keysToTypeIn[cleanKey(category)] = type;
        keysToNamesIn[cleanKey(category)] = category;
        searchResults[cleanKey(category)] = [];
      }
    };

    const updateKeyValueArray = (arr: any, searchBlock: any, blockData: any) => {
      arr[cleanKey(searchBlock.category)]?.push({
        path: searchBlock.path,
        iconPath: searchBlock.iconPath,
        appId: blockData.appId,
        date: blockData.date,
        name: blockData.label,
        text: blockData.name,
        flag: blockData.flag,
      });
    };

    const updateArrowStringArray = (arr: any, searchBlock: any, blockData: any) => {
      arr[cleanKey(searchBlock.category)]?.push({
        path: blockData.path,
        appId: blockData.appId,
        date: blockData.date,
        name: blockData.name,
        text: blockData.name,
        icon: blockData.icon,
      });
    };

    const updateArrowStringInDataArray = (arr: any, searchBlock: any, blockData: any, inData: string) => {
      arr[cleanKey(searchBlock.category)]?.push({
        path: blockData.path,
        appId: blockData.appId,
        date: blockData.date,
        name: blockData.name,
        text: inData,
        icon: blockData.icon,
      });
    };

    searchData.forEach((searchBlock: any) => {
      searchBlock.data?.forEach((blockData: any) => {
        if (searchBlock.type === 'keyValue') {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(searchResults, searchBlock, blockData);
        } else if (searchBlock.type === 'arrowString') {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(searchResults, searchBlock, blockData);
          blockData.data?.forEach((inData: any) => {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(searchResults, searchBlock, blockData, inData);
          });
        }
      });
    });
    const searchResultsArrIn: any = [];
    Object.entries(searchResults).forEach(([key, value]: any) => {
      searchResultsArrIn.push({ name: key, data: value });
    });
    searchResultsArrIn.sort((a: any, b: any) => (a.data.length > b.data.length ? 1 : -1)).reverse();
    const searchResultsTabsIn = searchResultsArrIn.map((sr: any) => sr.name);
    const hasCategory = searchResultsTabsIn.indexOf(searchResultsSection);
    if (Number(hasCategory) > -1) {
      setValue(String(searchResultsTabsIn.indexOf(searchResultsSection) + 1));
    } else {
      setValue('0');
      setSearchResultsSection('');
    }

    const searchResultsTotal = searchResultsArrIn.reduce((acc: any, arr: any) => acc + arr.data.length, 0);

    setKeysToType(keysToTypeIn);
    setKeysToNames(keysToNamesIn);
    setSearchTabs(searchResultsTabsIn);
    setSearchResultsArr(searchResultsArrIn);
    setSearchResultsTotal(searchResultsTotal);
    return;
  }
  const searchResults: { [key: string]: any } = {};
  const keysToNamesIn: { [key: string]: any } = {};
  const keysToTypeIn: { [key: string]: any } = {};

  const setBlockIfNeeded = (category: string, type: string) => {
    if (!searchResults[cleanKey(category)]) {
      keysToTypeIn[cleanKey(category)] = type;
      keysToNamesIn[cleanKey(category)] = category;
      searchResults[cleanKey(category)] = [];
    }
  };

  const keyValueNameExactMatch: { [key: string]: any } = {};
  const keyValueNameMatchFirstUpper: { [key: string]: any } = {};
  const keyValueNameMatchUpper: { [key: string]: any } = {};
  const keyValueNameMatchLower: { [key: string]: any } = {};
  const keyValueNameMatchStart: { [key: string]: any } = {};
  const keyValueNameMatchWordStart: { [key: string]: any } = {};
  const keyValueNameMatchWordMiddle: { [key: string]: any } = {};
  const keyValueNameMatchWordEnd: { [key: string]: any } = {};
  const keyValueNameIncludes: { [key: string]: any } = {};
  const keyValueTextExactMatch: { [key: string]: any } = {};
  const keyValueTextMatchFirstUpper: { [key: string]: any } = {};
  const keyValueTextMatchUpper: { [key: string]: any } = {};
  const keyValueTextMatchLower: { [key: string]: any } = {};
  const keyValueTextMatchStart: { [key: string]: any } = {};
  const keyValueTextMatchWordStart: { [key: string]: any } = {};
  const keyValueTextMatchWordMiddle: { [key: string]: any } = {};
  const keyValueTextMatchWordEnd: { [key: string]: any } = {};
  const keyValueTextIncludes: { [key: string]: any } = {};
  const arrowStringExactMatch: { [key: string]: any } = {};
  const arrowStringMatchWordStart: { [key: string]: any } = {};
  const arrowStringStartsWith: { [key: string]: any } = {};
  const arrowStringMatchWordMiddle: { [key: string]: any } = {};
  const arrowStringMatchWordEnd: { [key: string]: any } = {};
  const arrowStringIncludes: { [key: string]: any } = {};

  const updateKeyValueArray = (arr: any, searchBlock: any, blockData: any) => {
    if (!arr[cleanKey(searchBlock.category)]) arr[cleanKey(searchBlock.category)] = [];
    arr[cleanKey(searchBlock.category)]?.push({
      path: searchBlock.path,
      iconPath: searchBlock.iconPath,
      appId: blockData.appId,
      date: blockData.date,
      name: blockData.label,
      text: blockData.name,
      flag: blockData.flag,
    });
  };

  const updateArrowStringArray = (arr: any, searchBlock: any, blockData: any) => {
    if (!arr[cleanKey(searchBlock.category)]) arr[cleanKey(searchBlock.category)] = [];
    arr[cleanKey(searchBlock.category)]?.push({
      path: blockData.path,
      appId: blockData.appId,
      date: blockData.date,
      name: blockData.name,
      text: blockData.name,
      icon: blockData.icon,
    });
  };

  const updateArrowStringInDataArray = (arr: any, searchBlock: any, blockData: any, inData: string) => {
    if (!arr[cleanKey(searchBlock.category)]) arr[cleanKey(searchBlock.category)] = [];
    arr[cleanKey(searchBlock.category)]?.push({
      path: blockData.path,
      appId: blockData.appId,
      date: blockData.date,
      name: blockData.name,
      text: inData,
      icon: blockData.icon,
    });
  };

  searchData.forEach((searchBlock: any) => {
    searchBlock.data?.forEach((blockData: any) => {
      if (searchBlock.type === 'keyValue') {
        if (blockData.label === debouncedSearchValue) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameExactMatch, searchBlock, blockData);
        } else if (blockData.label === `${debouncedSearchValue?.[0].toUpperCase()}${debouncedSearchValue.slice(1)}`) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchFirstUpper, searchBlock, blockData);
        } else if (blockData.label === debouncedSearchValue?.toUpperCase()) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchUpper, searchBlock, blockData);
        } else if (blockData.label === debouncedSearchValue?.toLowerCase()) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchLower, searchBlock, blockData);
        } else if (blockData.label?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()} `)) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchWordMiddle, searchBlock, blockData);
        } else if (
          blockData.label &&
          blockData.label.length > debouncedSearchValue.length &&
          blockData.label.substring(0, debouncedSearchValue.length + 1) === debouncedSearchValue + ' '
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchWordStart, searchBlock, blockData);
        } else if (
          blockData.label &&
          blockData.label.length >= debouncedSearchValue.length &&
          blockData.label.substring(0, debouncedSearchValue.length).toUpperCase() ===
            debouncedSearchValue?.toUpperCase()
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchStart, searchBlock, blockData);
        } else if (blockData.label?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()}`)) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameMatchWordEnd, searchBlock, blockData);
        } else if (blockData.label?.toLowerCase().includes(debouncedSearchValue?.toLowerCase())) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueNameIncludes, searchBlock, blockData);
        } else if (blockData.name === debouncedSearchValue) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextExactMatch, searchBlock, blockData);
        } else if (blockData.name === `${debouncedSearchValue?.[0].toUpperCase()}${debouncedSearchValue.slice(1)}`) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchFirstUpper, searchBlock, blockData);
        } else if (blockData.name === debouncedSearchValue?.toUpperCase()) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchUpper, searchBlock, blockData);
        } else if (blockData.name === debouncedSearchValue?.toLowerCase()) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchLower, searchBlock, blockData);
        } else if (blockData.name?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()} `)) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchWordMiddle, searchBlock, blockData);
        } else if (
          blockData.name &&
          blockData.name.length > debouncedSearchValue.length &&
          blockData.name.substring(0, debouncedSearchValue.length + 1) === debouncedSearchValue + ' '
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchWordStart, searchBlock, blockData);
        } else if (
          blockData.name &&
          blockData.name.length >= debouncedSearchValue.length &&
          blockData.name.substring(0, debouncedSearchValue.length).toUpperCase() === debouncedSearchValue?.toUpperCase()
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchStart, searchBlock, blockData);
        } else if (blockData.name?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()}`)) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextMatchWordEnd, searchBlock, blockData);
        } else if (blockData.name?.toLowerCase().includes(debouncedSearchValue?.toLowerCase())) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateKeyValueArray(keyValueTextIncludes, searchBlock, blockData);
        }
      } else if (searchBlock.type === 'arrowString') {
        if (blockData.name?.toLowerCase() === debouncedSearchValue?.toLowerCase()) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringExactMatch, searchBlock, blockData);
        } else if (
          blockData.name &&
          blockData.name.length > debouncedSearchValue.length &&
          (blockData.name.toLowerCase().substring(0, debouncedSearchValue.length + 1) ===
            debouncedSearchValue.toLowerCase() + ' ' ||
            blockData.name.toLowerCase().substring(0, debouncedSearchValue.length + 1) ===
              debouncedSearchValue.toLowerCase() + '.')
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringMatchWordStart, searchBlock, blockData);
        } else if (
          blockData.name &&
          blockData.name.length > debouncedSearchValue.length &&
          blockData.name.toLowerCase().substring(0, debouncedSearchValue.length) === debouncedSearchValue.toLowerCase()
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringStartsWith, searchBlock, blockData);
        } else if (
          blockData.name?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()} `) ||
          blockData.name?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()} `) ||
          blockData.name?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()}.`)
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringMatchWordMiddle, searchBlock, blockData);
        } else if (
          blockData.name?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()}`) ||
          blockData.name?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()}`)
        ) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringMatchWordEnd, searchBlock, blockData);
        } else if (blockData.name?.toLowerCase().includes(debouncedSearchValue?.toLowerCase())) {
          setBlockIfNeeded(searchBlock.category, searchBlock.type);
          updateArrowStringArray(arrowStringIncludes, searchBlock, blockData);
        }
        blockData.data?.forEach((inData: any) => {
          if (inData?.toLowerCase() === debouncedSearchValue?.toLowerCase()) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringExactMatch, searchBlock, blockData, inData);
          } else if (
            inData &&
            inData.length > debouncedSearchValue.length &&
            (inData.substring(0, debouncedSearchValue.length + 1) === debouncedSearchValue + ' ' ||
              inData.substring(0, debouncedSearchValue.length + 1) === debouncedSearchValue + '.')
          ) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringMatchWordStart, searchBlock, blockData, inData);
          } else if (
            inData &&
            inData.length > debouncedSearchValue.length &&
            inData.substring(0, debouncedSearchValue.length) === debouncedSearchValue
          ) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringStartsWith, searchBlock, blockData, inData);
          } else if (
            inData?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()} `) ||
            inData?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()} `) ||
            inData?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()}.`)
          ) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringMatchWordMiddle, searchBlock, blockData, inData);
          } else if (
            inData?.toLowerCase().includes(` ${debouncedSearchValue?.toLowerCase()}`) ||
            inData?.toLowerCase().includes(`.${debouncedSearchValue?.toLowerCase()}`)
          ) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringMatchWordEnd, searchBlock, blockData, inData);
          } else if (inData?.toLowerCase().includes(debouncedSearchValue?.toLowerCase())) {
            setBlockIfNeeded(searchBlock.category, searchBlock.type);
            updateArrowStringInDataArray(arrowStringIncludes, searchBlock, blockData, inData);
          }
        });
      }
    });
    if (searchBlock.type === 'keyValue') {
      const sortedKeyValueNameMatchWordStart = sortByIndex(
        keyValueNameMatchWordStart[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedKeyValueNameMatchWordMiddle = sortByIndex(
        keyValueNameMatchWordMiddle[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedKeyValueNameMatchWordEnd = sortByIndex(
        keyValueNameMatchWordEnd[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedKeyValueNameIncludes = sortByIndex(
        keyValueNameIncludes[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedKeyValueTextMatchWordStart = sortByIndex(
        keyValueTextMatchWordStart[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'text',
      );
      const sortedKeyValueTextMatchWordMiddle = sortByIndex(
        keyValueTextMatchWordMiddle[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'text',
      );
      const sortedKeyValueTextMatchWordEnd = sortByIndex(
        keyValueTextMatchWordEnd[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'text',
      );
      const sortedKeyValueTextIncludes = sortByIndex(
        keyValueTextIncludes[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'text',
      );
      const mergedResults = (keyValueNameExactMatch[cleanKey(searchBlock.category)] || [])
        .concat(keyValueNameMatchFirstUpper[cleanKey(searchBlock.category)] || [])
        .concat(keyValueNameMatchUpper[cleanKey(searchBlock.category)] || [])
        .concat(keyValueNameMatchLower[cleanKey(searchBlock.category)] || [])
        .concat(sortedKeyValueNameMatchWordStart || [])
        .concat(keyValueNameMatchStart[cleanKey(searchBlock.category)] || [])
        .concat(sortedKeyValueNameMatchWordMiddle || [])
        .concat(sortedKeyValueNameMatchWordEnd || [])
        .concat(sortedKeyValueNameIncludes || [])
        .concat(keyValueTextExactMatch[cleanKey(searchBlock.category)] || [])
        .concat(keyValueTextMatchFirstUpper[cleanKey(searchBlock.category)] || [])
        .concat(keyValueTextMatchUpper[cleanKey(searchBlock.category)] || [])
        .concat(keyValueTextMatchLower[cleanKey(searchBlock.category)] || [])
        .concat(sortedKeyValueTextMatchWordStart || [])
        .concat(keyValueTextMatchStart[cleanKey(searchBlock.category)] || [])
        .concat(sortedKeyValueTextMatchWordMiddle || [])
        .concat(sortedKeyValueTextMatchWordEnd || [])
        .concat(sortedKeyValueTextIncludes || []);
      searchResults[cleanKey(searchBlock.category)] = mergedResults;
    } else if (searchBlock.type === 'arrowString') {
      const sortedArrowStringMatchWordStart = sortByIndex(
        arrowStringMatchWordStart[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedArrowStringStartsWith = sortByIndex(
        arrowStringStartsWith[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedArrowStringMatchWordMiddle = sortByIndex(
        arrowStringMatchWordMiddle[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedArrowStringMatchWordEnd = sortByIndex(
        arrowStringMatchWordEnd[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const sortedArrowStringIncludes = sortByIndex(
        arrowStringIncludes[cleanKey(searchBlock.category)],
        debouncedSearchValue,
        'name',
      );
      const mergedArrowStringResults = (arrowStringExactMatch[cleanKey(searchBlock.category)] || [])
        .concat(sortedArrowStringMatchWordStart || [])
        .concat(sortedArrowStringStartsWith || [])
        .concat(sortedArrowStringMatchWordMiddle || [])
        .concat(sortedArrowStringMatchWordEnd || [])
        .concat(sortedArrowStringIncludes || []);
      searchResults[cleanKey(searchBlock.category)] = mergedArrowStringResults;
    }
  });
  const searchResultsArrIn: any = [];
  Object.entries(searchResults).forEach(([key, value]: any) => {
    searchResultsArrIn.push({ name: key, data: value });
  });
  const searchResultsTabsIn = searchResultsArrIn.map((sr: any) => sr.name);
  const hasCategory = searchResultsTabsIn.indexOf(searchResultsSection);
  if (Number(hasCategory) > -1) {
    setValue(String(searchResultsTabsIn.indexOf(searchResultsSection) + 1));
  } else {
    setValue('0');
    setSearchResultsSection('');
  }

  const searchResultsTotal = searchResultsArrIn.reduce((acc: any, arr: any) => acc + arr.data.length, 0);

  setKeysToType(keysToTypeIn);
  setKeysToNames(keysToNamesIn);
  setSearchTabs(searchResultsTabsIn);
  setSearchResultsArr(searchResultsArrIn);
  setSearchResultsTotal(searchResultsTotal);
};
